import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundaryFallback } from './ErrorBoundaryFallback';
import "components/@ui/custom.css"

// Suppress ResizeObserver errors in development
const resizeObserverErr = /ResizeObserver loop limit exceeded|ResizeObserver loop completed with undelivered notifications/;
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args[0]?.toString() || '';
  if (!resizeObserverErr.test(message)) {
    originalConsoleError.call(console, ...args);
  }
};

// Suppress unhandled errors to prevent error overlay
window.addEventListener('error', (event) => {
  if (resizeObserverErr.test(event.message)) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return false;
  }
}, true);

// Also suppress unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.toString() || '';
  if (resizeObserverErr.test(message)) {
    event.preventDefault();
    return false;
  }
});

// Inject script into DOM to suppress overlay before React loads
const suppressOverlay = document.createElement('script');
suppressOverlay.textContent = `
  window.addEventListener('error', function(e) {
    if (e.message && e.message.includes('ResizeObserver')) {
      e.preventDefault();
      e.stopPropagation();
      return true;
    }
  }, true);
  
  window.addEventListener('unhandledrejection', function(e) {
    if (e.reason && e.reason.toString().includes('ResizeObserver')) {
      e.preventDefault();
      return true;
    }
  });
`;
document.head.appendChild(suppressOverlay);

function mountApp() {
  let rootEl = document.getElementById('root');
  if (!rootEl && document.body) {
    rootEl = document.createElement('div');
    rootEl.id = 'root';
    document.body.appendChild(rootEl);
  }
  if (!rootEl) {
    document.body.innerHTML = '<div style="padding:20px;font-family:sans-serif">No #root element found.</div>';
    return;
  }
  try {
    ReactDOM.render(
      <ErrorBoundaryFallback>
        <App />
      </ErrorBoundaryFallback>,
      rootEl
    );
  } catch (err) {
    console.error('Initial render failed:', err);
    rootEl.innerHTML = `<div style="padding:20px;font-family:monospace;background:#1a1a1a;color:#ff6b6b;min-height:100vh"><h1>Initial load error</h1><pre>${(err as Error)?.message || String(err)}</pre></div>`;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp);
} else {
  mountApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
